import React, { useState } from 'react';
import { withRouter, NavLink as Link } from 'react-router-dom';


function SideNavItem(props) {
  let expandedDefaultValue = false;
  let childSelected = false;
  const activeRoute = props.location.pathname;

  // if current item or child item is active, expand by default
  if (
    activeRoute === props.route ||
    (props.activeRoutes && props.activeRoutes.indexOf(activeRoute) >= 0)
  ) {
    expandedDefaultValue = true;
  } else if (props.subRoutes && props.subRoutes.indexOf(activeRoute) >= 0) {
    expandedDefaultValue = true;
  }

  if (props.subRoutes && (props.subRoutes.indexOf(activeRoute) >= 0 || props.subRoutes == activeRoute))
    childSelected = true;

  const [expanded, setExpanded] = useState(expandedDefaultValue);

  return (
    <li>
      <Link
        exact
        to={props.route}
        isActive={() =>
          activeRoute === props.route ||
          (props.activeRoutes && props.activeRoutes.indexOf(activeRoute) >= 0)
        }
        activeClassName="is-active"
        onClick={() => {
          if (props.onClick) {
            props.onClick();
          }

          setExpanded(!expanded);
        }}
        className={`${props.className || ''} ${childSelected ? 'child-selected' : ''}`}
        automationid={props.automationid}
      >
        {props.iconName && (
          <span className={`menu-item-icon is-icon-4 has-padding-right-6 ${props.iconName}`}></span>
        )}
        {props.name}
      </Link>
      <section className="side-nav-sub-menu">
        {expanded && props.children}
      </section>
    </li>
  );
}

export default withRouter(SideNavItem);
